import React from 'react';
import { MinusCircleOutlined } from '@ant-design/icons';
import { Button, Form, Input, InputNumber, Select, Space } from 'antd';
import  { MaterialSummaryRowProps } from '../../interfaces';

const MaterialSummaryRow: React.FC<MaterialSummaryRowProps> = ({
  field,
  index,
  materialTemplates,
  requiresSizes,
  onMaterialChange,
  onRemove,
}) => (
  <Space align="start" className="admin-product-form__material-row">
    <Form.Item name={[field.name, 'materialName']} label={index === 0 ? 'Material Name' : ''} rules={[{ required: true, message: 'Material is required.' }]} className="admin-product-form__material-name">
      <Select
        showSearch
        placeholder="Select material"
        optionFilterProp="label"
        options={materialTemplates.map((material) => ({
          value: material.materialName,
          label: material.materialName,
        }))}
        onChange={(value) => onMaterialChange(field.name, value)}
      />
    </Form.Item>
    <Form.Item name={[field.name, 'price']} label={index === 0 ? 'Material Price' : ''} rules={[{ required: true, message: 'Enter material price.' }, { type: 'number', min: 1, message: 'Material price must be greater than 0.' }]} className="admin-product-form__material-price">
      <InputNumber min={1} style={{ width: '100%' }} />
    </Form.Item>
    {requiresSizes ? (
      <Form.Item name={[field.name, 'stockQuantity']} className="admin-product-form__material-hidden">
        <Input type="hidden" />
      </Form.Item>
    ) : (
      <Form.Item name={[field.name, 'stockQuantity']} label={index === 0 ? 'In Stock' : ''} rules={[{ required: true, message: 'Enter stock quantity.' }, { type: 'number', min: 0, message: 'Stock cannot be negative.' }]} className="admin-product-form__material-price">
        <InputNumber min={0} style={{ width: '100%' }} />
      </Form.Item>
    )}
    <Form.Item name={[field.name, 'materialIconId']} className="admin-product-form__material-hidden">
      <Input type="hidden" />
    </Form.Item>
    <Button danger type="text" icon={<MinusCircleOutlined />} onClick={() => onRemove(field.name)} className="admin-product-form__remove-material">
      Remove
    </Button>
  </Space>
);

export default MaterialSummaryRow;
